import SetIsActive from '@/common/components/SetIsActive'
import { BrokeNotificationData } from '@/modules/client-setting/type'
import useMutationUpdateBrokeNotification from '@/modules/client-setting/api/hooks/useMutationUpdateBrokeNotification'

interface SwitchIsActiveProps {
	row: BrokeNotificationData
}

export function IsActiveBrokeNotification({ row }: SwitchIsActiveProps) {
	const { mutateAsync: updateBrokeNotification } =
		useMutationUpdateBrokeNotification()

	const handleMutate = async (value: boolean) => {
		await updateBrokeNotification({
			id: row.id,
			payload: {
				isActive: value,
			},
		})
	}

	return <SetIsActive defaultChecked={row.isActive} onMutate={handleMutate} />
}
